import { render, staticRenderFns } from "./SocialFollow.vue?vue&type=template&id=77d0d345&scoped=true&"
import script from "./SocialFollow.vue?vue&type=script&lang=js&"
export * from "./SocialFollow.vue?vue&type=script&lang=js&"
import style0 from "./SocialFollow.vue?vue&type=style&index=0&id=77d0d345&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0d345",
  null
  
)

export default component.exports